import { useState } from 'react';
import ToolbarButtonWithDropdown from '../ToolbarButtonWithDropdown';
import {
  AlignCenterIcon,
  AlignLeftIcon,
  AlignRightIcon,
  JustifyIcon,
} from '../icons';
import AlignmentPicker from '../pickers/AlignmentPicker';

const ALIGNMENT_ICONS = {
  left: <AlignLeftIcon />,
  center: <AlignCenterIcon />,
  right: <AlignRightIcon />,
  justify: <JustifyIcon />,
};

export default function AlignmentButton({ editor }) {
  const [alignmentSelected, setAlignmentSelected] = useState('left');

  const handleChangeAlignment = (value) => {
    setAlignmentSelected(value);
    editor.chain().focus().setTextAlign(value).run();
  };

  return (
    <ToolbarButtonWithDropdown
      dropdownComponent={<AlignmentPicker onClick={handleChangeAlignment} />}
      aria-label="editor-alignment"
    >
      {ALIGNMENT_ICONS[alignmentSelected]}
    </ToolbarButtonWithDropdown>
  );
}
